export const getDeviceCoordinates = (successCallback) => {
  const isGeolocationAvailable = !!navigator.geolocation

  if (isGeolocationAvailable) {
    navigator.geolocation.getCurrentPosition(successCallback)
  }
}
